/** True when a Prismic link URL points somewhere; empty values and `#` placeholders do not. */
export const isNavigableUrl = (url?: string | null): url is string => {
  const trimmed = url?.trim();
  return Boolean(trimmed) && trimmed !== "#";
};
